import { render, staticRenderFns } from "./upload-list.vue?vue&type=template&id=3b5bd359&scoped=true&"
import script from "./upload-list.vue?vue&type=script&lang=js&"
export * from "./upload-list.vue?vue&type=script&lang=js&"
import style0 from "./upload-list.vue?vue&type=style&index=0&id=3b5bd359&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5bd359",
  null
  
)

export default component.exports